module.exports = __webpack_public_path__ + "img/hostel-1.b23a902c.jpg";